import { render } from "./TimingScoring.vue?vue&type=template&id=89368f52"
import script from "./TimingScoring.vue?vue&type=script&lang=js"
export * from "./TimingScoring.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__